export const APPLY_MAIN_HEADER_SETTINGS = "APPLY_MAIN_HEADER_SETTINGS";

const initState = {
  back: false,
  customizeAdd: false,
  showMenu: true,
  goToBack: () => {},
  className: "",
  viewName: "",
  backArrow: false,
};

export function mainHeaderSettings(store) {
  store.on("@init", () => {
    return { mainHeaderSettings: initState };
  });

  store.on(
    APPLY_MAIN_HEADER_SETTINGS,
    (
      { mainHeaderSettings },
      { showMenu, back, goToBack, customizeAdd, viewName, backArrow }
    ) => {
      return {
        mainHeaderSettings: {
          ...mainHeaderSettings,
          back: back,
          showMenu: showMenu,
          goToBack: goToBack,
          customizeAdd: customizeAdd,
          viewName: viewName,
          backArrow: backArrow,
        },
      };
    }
  );
}
